const host = typeof window !== "undefined" ? window.location?.hostname : "";
const isDev =
  host === "localhost" ||
  host === "127.0.0.1" ||
  host.includes("devinterviewbot");
const DEV_API = "https://testinterviewbot.kraftshala.com";
const PROD_API = "https://interviewservice.kraftshala.com";

export const SWAGGER_URL = isDev ? DEV_API : PROD_API;
